export const brokerGuidRes = [
  {
    step1: {
      activity: '544',
    },
  },
  {
    step2: {
      insuranceCover: 'CC',
      selectedCoverName: 'Commercial Combined',
    },
  },
  {
    step3: {
      tradingStartDate: '2019-08-02T21:00:00.000Z',
      hasInsurance: true,
      currentInsurerId: '78',
      currentInsurerOther: 'Other Insurer Detail',
    },
  },
  {
    step4: {
      publicLiabilityIndemnityLevel: '1000000',
      employersLiabilityCoverAmountLevel: '10000000',
    },
  },
  {
    step5: {
      locations: [
        {
          postcode: 'SL5 1PD',
          houseNo: 'Castle Pantry',
          street: '1 Castle Hill',
          town: '',
          city: 'Windsor',
          county: 'Berkshire',
        },
        {
          postcode: 'MOX12 3R',
          houseNo: 'Castle Pantry',
          street: '1 Castle Hill',
          county: 'Berkshire',
          town: '',
          city: 'Windsor',
        },
      ],
      operatesAnotherLocation: true,
    },
  },
  {
    step6: [
      {
        id: 1,
        title: 'Building cover',
        info: {
          header: 'Building cover',
          content:
            'Please enter the current rebuild value for the buildings if cover is required',
        },
        added: false,
        values: [['50'], ['100']],
      },
      {
        values: [[''], ['']],
        added: false,
        id: 2,
        title: 'Contents/Plant & Machinery',
      },
      {
        id: 13,
        title: 'Tenants Improvement',
        added: false,
        values: [['500'], ['1000']],
      },
      {
        values: [[''], ['']],
        added: false,
        id: 14,
        title: 'Rent payable',
      },
      {
        values: [[''], ['']],
        added: false,
        id: 8,
        title: 'Computer/Office Equipment',
      },
      {
        id: 15,
        title: 'Glass Sum Insured',
        added: false,
        values: [['250'], ['500']],
      },
      {
        values: [[''], ['']],
        added: false,
        id: 3,
        title: 'Stock in Trade',
      },
      {
        values: [[''], ['']],
        added: false,
        id: 5,
        title: 'Portable Hand Tools',
      },
      {
        values: [[''], ['']],
        added: false,
        id: 4,
        title: 'Wine/Spirits/Tobacco',
      },
      {
        values: [[''], ['']],
        added: false,
        id: 7,
        title: 'Portacabins',
      },
      {
        values: [
          {
            vehicleDetails: {
              maxValue: '5000',
              vehiclesInTheOpen: '30',
              vehiclesInCompound: '15',
              vehiclesInBuilding: '5',
            },
          },
          {
            vehicleDetails: {
              maxValue: '2000',
              vehiclesInTheOpen: '60',
              vehiclesInCompound: '40',
              vehiclesInBuilding: '20',
            },
          },
        ],
        added: true,
        id: 11,
        title: 'Vehicles at premises',
      },
    ],
  },
  {
    step7: {
      contactAddress: {
        postcode: 'SL 5R34',
        address1: 'Castle Pantry',
        address2: '1 Castle Hill',
        town: '',
        city: 'Windsor',
        county: 'Berkshire',
        showAddress: true,
      },
      tradingAs: 'Trading name is different',
      policyHolderSurname: 'SurNamee',
      policyHolderFirstName: 'FirstName',
      policyHolderTitleId: '1',
      businessTypeId: '1',
      additional: {
        specifiedAllRisksCoverAdded: true,
        specifiedAllRisksTypes: [
          {
            selected: false,
            text: '',
            id: 0,
          },
          {
            selected: true,
            sumInsuredWW: 30,
            sumInsuredEU: 20,
            sumInsuredUK: 10,
            text: '',
            id: 0,
          },
          {
            selected: false,
            text: '',
            id: 0,
          },
          {
            selected: false,
            text: '',
            id: 0,
          },
        ],
        specifiedAllRisksMaxValueSingle: 2000,
        detoriationOfStockSum: [500, 1000],
        detoriationOfStockCoverAdded: true,
        personalAccidentCoverAdded: true,
        personalAccidentAnyInsuredApplicationDeclinedOrImposed: true,
        personalAccidentAnyInsuredApplicationDeclinedOrImposedDetails:
          'personal accident detail test',
        personalAccidentAnyInsuredOver70: true,
        personalAccidentUnitsRequired: 5,
        lossOfLicenceCoverAdded: true,
        lossOfLicencePreviousPendingConvictions: true,
        lossOfLicencePreviousPendingConvictionsDetails: 'test law',
        lossOfLicencePreviousWarningsOrNotices: true,
        lossOfLicencePreviousWarningsOrNoticesDetails: 'warning license',
        lossOfLicenceIssuingAuthority: 'Test Authority',
        lossOfLicenceDateOfIssue: '2024-08-14T21:00:00.000Z',
        lossOfLicenceSumInsured: 450,
        lossOfLicenceType: 'Test License',
        stock: true,
        stock_details: 100,
        portable: true,
        portable_details: 50,
        goodsInTransitCoverAdded: true,
        goodsInTransitMaxValueSingleTransit: 300,
        goodsInTransitAnnualValue: 150,
        moneyCoverAdded: true,
        moneyAtAllPremisesOutBusinessHourAndInSafe: '50',
        moneyAtAllPremisesOutBusinessHourAndNotInSafe: '40',
        moneyAtAllPremisesBusinessHour: '30',
        moneyInTransitToFromBank: '20',
        moneyAnnualCarrying: '10',
        businessInterruptionCoverAdded: true,
        businessInterruptionBasisIfCoverId: '1',
        businessInterruptionIndemnityPeriodId: '1',
        businessInterruptionSum: [50, 100],
        personalAccidentAnyInsuredPreExistingConditions: 'pre existing details',
      },
      vehicles_details: {},
    },
  },
  {
    step8: {
      annualClericalWageRoll: 20,
      annualManualWageRoll: 10,
      annualTurnover: 200,
      tradeTypeId: '1',
      activities: [
        {
          title: 'Art Galleries',
          occupationId: '544',
          percentage: 50,
        },
        {
          percentage: 50,
          occupationId: '28',
          title: 'Art gallery',
        },
      ],
    },
  },
  {
    step9: {
      numberOfManualEmployees: 5,
      numberOfClericalEmployees: 6,
      operatePAYE: true,
      ern: '123/xs-r2d2',
      ernExempt: false,
    },
  },
  {
    step10: {
      employBonaFideSubcontract: true,
      employBonaFideSubcontractPercentage: '45',
    },
  },
  {
    step11: {
      exportGoodsOutsideUK: true,
      exportGoodsToEuropePercentage: '10',
      exportGoodsToUsaCanadaPercentage: '20',
      exportGoodsToOtherPercentage: '30',
    },
  },
  {
    step12: {
      workInAboutVesselsDamsDocks: true,
      workInAboutVesselsDamsDocksDetails:
        'work in, on or about vessels, dams, reservoirs, docks, harbours',
      explosiveSubstances: true,
      explosiveSubstancesDetails: 'explosive substances',
      radioactiveSubstancesOrDevices: true,
      radioactiveSubstancesOrDevicesDetails:
        'radioactive substances or devices detail',
    },
  },
  {
    step13: {
      undertakenWork: true,
      undertakenWorkPercentage: '56',
    },
  },
  {
    step14: {
      declarationBankrupt: true,
      declarationBankruptDetails: 'declared bankrupt detail',
    },
  },
  {
    step15: {
      claim: true,
      claims: [
        {
          propertyOptions: 'Fire',
          claim_future: 'tried to prevent as much as possible ',
          description: 'full claim detail',
          value: '100',
          claim_type: 'Property',
          made_claim: 'Thu Aug 15 2024 00:00:00 GMT+0300 (GMT+03:00)',
        },
      ],
    },
  },
  {
    step16: {
      retainRightsOfRecovery: false,
      importProductsOrMaterialsOutsideUK: true,
      retainRightsOfRecoveryDetails: 'more details',
      importProductsOrMaterialsOutsideUKDetails: 'full details of step16',
    },
  },
  {
    step17: {
      goodsSuppliedRecordsKept: false,
      goodsSuppliedRecordsKeptDetails: 'reasonWhy on step17',
    },
  },
  {
    step18: {
      carryOutPractices: false,
      carryOutPracticesDetails: 'provided details of step18 ',
    },
  },
  {
    step19: {
      locations: [
        {
          entirelySelfContained: false,
          entirelySelfContainedDetails: 'means of access detail',
          gradeOrCategory: true,
          gradeOrCategoryId: '2*/B',
          inGoodStateAndMaintained: false,
          inGoodStateAndMaintainedDetails: 'repair and maintain step 19 ',
          heatedSolelyByElectricityOrGas: false,
          heatedSolelyByElectricityOrGasDetails: 'electricty details',
          flatRoof: true,
          flatRoofPercentage: 50,
          hasBuildOfBrickStoneOrConcrete: false,
          hasBuildOfBrickStoneOrConcreteDetails:
            'Built of brick, stone or concrete and roofed with slates, tiles, concrete, metal or asbestos?\n details',
        },
        {
          entirelySelfContained: false,
          entirelySelfContainedDetails: 'means of access detail',
          gradeOrCategory: true,
          gradeOrCategoryId: '2*/B',
          inGoodStateAndMaintained: false,
          maintainedDetails: 'repair and maintain step 19 ',
          heatedSolelyByElectricityOrGas: false,
          heatedSolelyByElectricityOrGasDetails: 'electricty details',
          flatRoof: true,
          flatRoofPercentage: 50,
          hasBuildOfBrickStoneOrConcrete: false,
          hasBuildOfBrickStoneOrConcreteDetails:
            'Built of brick, stone or concrete and roofed with slates, tiles, concrete, metal or asbestos?\n details',
        },
      ],
    },
  },
  {
    step20: {
      locations: [
        {
          hasFrostStateActivatedOrPipesLagged: false,
          portableHeaters: true,
          portableHeatersDetails: 'tested step 20 ',
        },
        {
          hasFrostStateActivatedOrPipesLagged: false,
          portableHeaters: true,
          portableHeatersDetails: 'tested step 20 ',
        },
      ],
    },
  },
  {
    step21: {
      locations: [
        {
          ageOfOldestPart: 2020,
          detachedFromNeighbouringProperties: false,
          adjoiningOccupantsBusinessActivitiesDetails: 'detached step 21',
        },
        {
          ageOfOldestPart: 2020,
          detachedFromNeighbouringProperties: false,
          adjoiningOccupantsBusinessActivitiesDetails: 'detached step 21',
        },
      ],
    },
  },
  {
    step22: {
      locations: [
        {
          hasWholeElectricalSystemInspected: true,
          electricalConditionReport: true,
          hasPortableApplianceTesting: true,
        },
        {
          hasWholeElectricalSystemInspected: true,
          electricalConditionReport: true,
          hasPortableApplianceTesting: true,
        },
      ],
    },
  },
  {
    step23: {
      locations: [
        {
          isLetAsResidentalAccommodation: true,
          gasCertifcateIssuedByGasSafeRegisteredEngineer: true,
          hasValidGasAnnualSafety: true,
        },
        {
          isLetAsResidentalAccommodation: true,
          gasCertifcateIssuedByGasSafeRegisteredEngineer: true,
          hasValidGasAnnualSafety: true,
        },
      ],
    },
  },
  {
    step24: {
      locations: [
        {
          haveBeenFloodedInTheLast10Years: true,
          haveBeenFloodedInTheLast10YearsDetails: 'premises detail step24',
          burningWasteCarriedOutAtPremises: true,
          burningWasteCarriedOutAtPremisesDetails:
            'step24 detail burning waste',
        },
        {
          haveBeenFloodedInTheLast10Years: true,
          haveBeenFloodedInTheLast10YearsDetails: 'premises detail step24',
          burningWasteCarriedOutAtPremises: true,
          burningWasteCarriedOutAtPremisesDetails:
            'step24 detail burning waste',
        },
      ],
    },
  },
  {
    step25: {
      locations: [
        {
          subsidenceGroundHeaveLandslipCoverAdded: true,
          subsidenceGroundHeaveLandslipCoverAddedRestrictionsApply: true,
          subsidenceGroundHeaveLandslipDetails: 'step25 detailed answer',
        },
        {
          subsidenceGroundHeaveLandslipCoverAdded: true,
          subsidenceGroundHeaveLandslipCoverAddedRestrictionsApply: true,
          subsidenceGroundHeaveLandslipDetails: 'step25 detailed answer',
        },
      ],
    },
  },
  {
    step26: {
      doorsAndWindowsSecured: false,
      doorsAndWindowsSecuredDetails: 'physical step26 ',
      intruderAlarm: true,
      intruderAlarmTypeId: 1,
      intruderAlarmAnnualMaintenance: false,
      safeOrVaultInstalled: true,
      safeOrVaultMake: '50',
      safeOrVaultModel: '60',
    },
  },
  {
    step27: {
      startDate: '2024-08-22T21:00:00.000Z',
      referralNotes: 'test notes of referral',
    },
  },
]
